module.exports = __webpack_public_path__ + "static/media/public.jwt.1e3bc103.pem";